import { render, staticRenderFns } from "./bannerCol.vue?vue&type=template&id=319b7c32&scoped=true&"
import script from "./bannerCol.vue?vue&type=script&lang=js&"
export * from "./bannerCol.vue?vue&type=script&lang=js&"
import style0 from "./bannerCol.vue?vue&type=style&index=0&id=319b7c32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b7c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('319b7c32')) {
      api.createRecord('319b7c32', component.options)
    } else {
      api.reload('319b7c32', component.options)
    }
    module.hot.accept("./bannerCol.vue?vue&type=template&id=319b7c32&scoped=true&", function () {
      api.rerender('319b7c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/bannerCol.vue"
export default component.exports